import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  CustomPresetDetailFieldsFragment,
  CustomPresetFieldsFragment,
  GetCustomPresetDocument,
  GetCustomPresetQuery,
  GetCustomPresetQueryVariables,
  GetCustomPresetsDocument,
  GetCustomPresetsQuery,
  GetCustomPresetsQueryVariables
} from '~/api/graphql';

export const getCustomPresets = async () =>
  queryData<GetCustomPresetsQuery, GetCustomPresetsQueryVariables, CustomPresetFieldsFragment[]>(
    client,
    { query: GetCustomPresetsDocument },
    (data) => data?.customPresets || []
  );

export const getCustomPreset = async (id: string) =>
  queryData<GetCustomPresetQuery, GetCustomPresetQueryVariables, CustomPresetDetailFieldsFragment>(
    client,
    { query: GetCustomPresetDocument, variables: { id: id } },
    (data) => data?.customPreset
  );

export const loadCustomPresets: LoaderFunction = () =>
  loadQuery(getCustomPresets(), { suppressAuthErrors: true });

export const loadCustomPreset: LoaderFunction = ({ params }) =>
  loadQuery(getCustomPreset(params.id || ''));

// Under a client, :id identifies the client rather than the preset.
export const loadClientCustomPreset: LoaderFunction = ({ params }) =>
  loadQuery(getCustomPreset(params.presetId || ''));
